/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeliveryType = {
    DELIVERY: 'DELIVERY',
    PICKUP: 'PICKUP'
} as const;
export type DeliveryType = typeof DeliveryType[keyof typeof DeliveryType];

